"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    PalletBalanceOf: 'Balance',
    AccountInfo: 'AccountInfoWithDualRefCount'
  }
};
exports.default = _default;